import { readPacket, writePacket } from '../../core/packets'
import { Location } from '../../core/Location'

import * as THREE from '../three'

import { System } from './System'
import { BrowserServer } from '../../server/BrowserServer'

const loc1 = new Location()

export class NetworkSystem extends System {
  constructor(client) {
    super(client)
    this.socket = null
    this.playerId = null
    this.packets = []
    this.connected = new Promise(resolve => {
      this.connectedResolve = resolve
    })
  }

  init({ socket }) {
    this.socket = socket
    this.socket.setReceiver(this)
  }

  start() {
    this.socket.connect()
  }

  // connect(socket) {
  //   this.socket = socket
  //   this.socket.setReceiver(this)
  //   this.socket.connect()
  // }

  preFixedUpdate() {
    while (this.packets.length) {
      try {
        const msg = this.packets.shift()
        this[msg.method]?.(msg.data)
      } catch (err) {
        console.error(err)
      }
    }
  }

  send(name, data) {
    if (!this.socket) return
    // console.log('->', name, data)
    this.socket.send(name, data)
  }

  onPacket = msg => {
    this.packets.push(msg)
    // console.log('<-', msg.method, msg.data)
  }

  onSnapshot(data) {
    console.log('snapshot', data)

    // generate icon/texture urls
    for (const asset of data.registry) {
      if (asset.type === 'icon') {
        const blob = new Blob([asset.data], { type: 'image/png' })
        asset.url = URL.createObjectURL(blob)
      } else if (asset.type === 'texture') {
        const blob = new Blob([asset.data], { type: 'image/png' })
        asset.url = URL.createObjectURL(blob)
      }
    }

    this.playerId = data.playerId
    this.client.registry.deserialize(data.registry)
    this.client.sky.setup(data.sky)
    this.client.media.setup(data.media)
    this.client.avatars.setup()
    this.client.chunks.setup(data.chunks)
    this.client.entities.setup(data.entities)
    this.client.inventory.setup(data.inventory)

    if (this.connectedResolve) {
      this.connectedResolve()
      this.connectedResolve = null
    }
  }

  onEntityAdded(data) {
    this.client.entities.add(data, false)
  }

  onEntityModified(data) {
    this.client.entities.modify(data, false)
  }

  onEntityRemoved(id) {
    this.client.entities.remove(id, false)
  }

  onChunkAdded(data) {
    this.client.chunks.add(data)
  }

  onChunkRebuilt(data) {
    this.client.chunks.rebuild(data)
  }

  onChunkRemoved(id) {
    this.client.chunks.remove(id)
  }

  // onVoxelsModified(changes) {
  //   for (const [voxel, state] of changes) {
  //     loc1.voxel.fromArray(voxel)
  //     const chunk = this.client.chunks.get(loc1.chunkId)
  //     if (!chunk) {
  //       console.warn('onVoxelsModified: chunk not found')
  //       continue
  //     }
  //     chunk.setStateAtIdx(loc1.voxelIdx, state)
  //   }
  // }

  onEditVoxels(changes) {
    this.client.chunks.onEditVoxels(changes)
  }

  onBlockAdded(item) {
    this.client.chunks.ensureItem(item)
  }

  onBlockDamage(data) {
    this.client.chunks.onBlockDamage(data)
  }

  onEditAssets(ops) {
    // generate icon/texture urls
    // todo: if upsert replaces existing asset those object urls should probably be URL.revokeObjectURL'd
    if (ops.upsert) {
      for (const asset of ops.upsert) {
        if (asset.type === 'icon') {
          const blob = new Blob([asset.data], { type: 'image/png' })
          asset.url = URL.createObjectURL(blob)
        } else if (asset.type === 'texture') {
          const blob = new Blob([asset.data], { type: 'image/png' })
          asset.url = URL.createObjectURL(blob)
        }
      }
    }
    this.client.registry.ops(ops)
  }

  onMediaMute(data) {
    this.client.media.setMuted(data.playerId, data.muted)
  }

  onMediaLevel(data) {
    this.client.media.setLevel(data.playerId, data.level)
  }

  onEquip([entityId, slot, item]) {
    const entity = this.client.entities.get(entityId)
    if (!entity) return console.log('[onEquip] no entity found to equip item')
    entity.equip(slot, item, false)
  }

  onClose = (code, reason) => {
    const info = { code, reason }
    console.log('onClose', info)
    this.client.emit('disconnect', info)
  }
}
